import gql from "graphql-tag";
import PinnablePostFields from "lib/graphql/fragments/engagement/PinnablePostFields";
import AnswerablePostFields from "lib/graphql/fragments/engagement/AnswerablePostFields";
import PostOrReplyAuthorFields from "./PostOrReplyAuthorFields";
import EditablePostFields from "./EditablePostFields";
import ReactableFields from "../ReactableFields";

export default gql`
  fragment PostReplyFields on PostReply {
    _id
    shortId
    objectId
    bodyAsJson
    bodyAsPlainText
    createdAt

    author {
      ...PostOrReplyAuthorFields
    }

    viewerDidAuthor
    viewerCanEdit
    viewerCanDestroy

    ...EditablePostFields
    ...PinnablePostFields
    ...AnswerablePostFields
    ...ReactableFields
  }

  ${EditablePostFields}
  ${PostOrReplyAuthorFields}
  ${PinnablePostFields}
  ${AnswerablePostFields}
  ${ReactableFields}
`;
